// extracted by mini-css-extract-plugin
module.exports =  {"container":"_13c3691929--container--OkXhv","header":"_13c3691929--header--gYIZZ","offers-wrapper":"_13c3691929--offers-wrapper--FHBIH"};